export const currentEnvironment = (() => {
  const localEnv = localStorage.getItem('REACT_APP_ENV');
  return localEnv || process.env.REACT_APP_ENV;
})();

export const getEnvironment = (): string | undefined => currentEnvironment;
